import {
  CPM_CREATE_SERVICE_FEE_RULE, CPM_DELETE_SERVICE_FEE_RULE, CPM_GET_SERVICE_FEE_RULE, CPM_LIST_SERVICE_FEE_RULES, CPM_UPDATE_SERVICE_FEE_RULE, REINIT_STATE,
} from '../../../constants/ActionTypes';
import { defaultPaginatedListResult } from '../../../constants/App';
import mServiceFeeRule from '../../../models/cpm/serviceFeeRule';

export const initialSettings = {
  create: {
    error: null,
    created: false,
  },
  delete: {
    error: null,
    deleted: false,
  },
  get: {
    error: null,
    loading: false,
    data: null,
  },
  list: {
    error: null,
    loading: false,
    elements: { ...defaultPaginatedListResult },
  },
  update: {
    error: null,
    updated: false,
  },
};

export const reducer = (state = initialSettings, action) => {
  switch (action.type) {
    // REINIT_STATE
    case REINIT_STATE:
      switch (action.target) {
        case 'createServiceFeeRule':
          return { ...state, create: initialSettings.create };
        case 'getServiceFeeRule':
          return { ...state, get: initialSettings.get };
        case 'deleteServiceFeeRule':
          return { ...state, delete: initialSettings.delete };
        case 'listServiceFeeRules':
          return { ...state, list: initialSettings.list };
        case 'updateServiceFeeRule':
          return { ...state, update: initialSettings.update };
        default:
          return state;
      }

    // CPM_GET_SERVICE_FEE_RULE
    case CPM_GET_SERVICE_FEE_RULE:
      return {
        ...state,
        get: {
          ...state.get,
          loading: true,
          error: null,
          data: null,
        },
      };
    case `${CPM_GET_SERVICE_FEE_RULE}_ERROR`:
      return {
        ...state,
        get: {
          ...state.get,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_SERVICE_FEE_RULE}_SUCCESS`:
      return {
        ...state,
        get: {
          ...state.get,
          loading: false,
          data: mServiceFeeRule.deserialize(action.data.getServiceFeeRule),
        },
      };

    // CPM_LIST_SERVICE_FEE_RULES
    case CPM_LIST_SERVICE_FEE_RULES:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_LIST_SERVICE_FEE_RULES}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_LIST_SERVICE_FEE_RULES}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            ...mServiceFeeRule.deserializePaginated(action.data.listServiceFeeRules),
          },
        },
      };

    // CPM_CREATE_SERVICE_FEE_RULE
    case CPM_CREATE_SERVICE_FEE_RULE:
      return {
        ...state,
        create: {
          ...state.create,
          created: false,
          error: null,
        },
      };
    case `${CPM_CREATE_SERVICE_FEE_RULE}_ERROR`:
      return {
        ...state,
        create: {
          ...state.create,
          created: false,
          error: action.error,
        },
      };
    case `${CPM_CREATE_SERVICE_FEE_RULE}_SUCCESS`:
      return {
        ...state,
        create: {
          ...state.create,
          created: true,
        },
      };

    // CPM_DELETE_SERVICE_FEE_RULE
    case CPM_DELETE_SERVICE_FEE_RULE:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case `${CPM_DELETE_SERVICE_FEE_RULE}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: action.error,
        },
      };
    case `${CPM_DELETE_SERVICE_FEE_RULE}_SUCCESS`:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };

    // CPM_UPDATE_SERVICE_FEE_RULE
    case CPM_UPDATE_SERVICE_FEE_RULE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${CPM_UPDATE_SERVICE_FEE_RULE}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_SERVICE_FEE_RULE}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/cpm/workspace/serviceFeeRule.js